export default __webpack_public_path__ + "static/media/gradient.4aae57e0.svg";